import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d19c302&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6d19c302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d19c302",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsBreadcrumbs: require('/var/web/bet777.es/components/elements/breadcrumbs.vue').default,SportMatches: require('/var/web/bet777.es/components/sport/matches.vue').default,ElementsLoader: require('/var/web/bet777.es/components/elements/loader.vue').default})
